"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functions = require("../../utilities/functions");

exports.default = {
  props: {
    accept: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    id: {
      type: String,
      required: true
    },

    options: {
      required: false,
      default: function _default() {
        return {
          maxSize: null
        };
      }
    }
  },

  data: function data() {
    return {
      file: null
    };
  },


  computed: {
    labelText: function labelText() {
      return this.file ? this.file.name : "Choose a file or drop it here...";
    }
  },

  methods: {
    fileLoaded: function fileLoaded(fileEvent) {
      var transfer = fileEvent.dataTransfer ? fileEvent.dataTransfer.files : [];
      var files = fileEvent.target.files || transfer;

      for (var f = 0; f < files.length; f++) {
        try {
          this.validate(files[f]);
        } catch (e) {
          this.$emit("file-failed");
          this.file = null;

          return this.$toastr.error(e);
        }

        this.file = files[f];
        this.$emit("file-loaded", this.file);
      }
    },


    /**
     * Validate file
     * @param file
     */
    validate: function validate(file) {
      if (this.options.maxSize && (0, _functions.filesize)(file.size).mb() > this.options.maxSize) {
        throw Error(this.$t("common.messages.large_file_size_error", {
          size: this.options.maxSize
        }));
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/FileInput.vue
// module id = cIpx
// module chunks = 0 1